const endpoints = {
  // auth
  login: "/api/v1/login",
  logout: "/api/v1/logout",
  forgotPassword: "/api/v1/forgot-password",
  verifyByOtp: "/api/v1/verify-by-otp",
  resetPassword: "/api/v1/reset-password",
  requestInvite: "/api/v1/invite-requests",
  register: "/api/v1/register",
  resendVerification: "/api/v1/resend-verification",

  // Ongoing Role
  onGoingRole: "/api/v1/on-going-roles",
  deleteOnGoingRole: id => `/api/v1/on-going-roles/${id}`,

  //Role Types
  getRoleTypes: "/api/v1/role-types",

  //Category
  getCategory: "/api/v1/public/categories",

  // Project:
  createProfileBatch: "/api/v1/projects/batch",
  deleteProject: id => `/api/v1/projects/${id}`,
  editProject: id => `/api/v1/projects/${id}`,
  /** My Profile — archived project member backups */
  getArchivedProjects: "/api/v1/project-backups/archive",
  restoreArchivedProject: projectMemberId =>
    `/api/v1/project-backups/${projectMemberId}/restore`,
  permanentlyDeleteArchivedProject: projectMemberId =>
    `/api/v1/project-backups/${projectMemberId}/permanent`,

  // public URL
  getCites: "/api/v1/public/cities",
  getPublicCity: id => `/api/v1/public/cities/${id}`,
  /** Public City Hub list mirrors — same shapes as member APIs, `/public` prefix. */
  getPublicCityCalls: cityId => `/api/v1/public/city/${cityId}/calls`,
  getPublicCityReviews: cityId => `/api/v1/public/city/${cityId}/reviews`,
  getPublicCityReviewById: (cityId, reviewId) =>
    `/api/v1/public/city/${cityId}/reviews/${reviewId}`,
  getPublicPhotography: "/api/v1/public/photography",
  getPublicPhotographyById: id => `/api/v1/public/photography/${id}`,
  getPublicSessions: "/api/v1/public/sessions",
  getPublicCityMembers: cityId => `/api/v1/public/members/${cityId}`,
  createCityUpdateRequest: "/api/v1/city-update-requests",
  getInvite: code => `/api/v1/public/invites/${code}`,

  // user
  getMe: "/api/v1/user/me",
  getUser: userId => `/api/v1/user/${userId}`,
  updateBasicProfile: "/api/v1/user/basic-profile",
  updatePassword: "/api/v1/user/update/password",
  updateTwoFactor: "/api/v1/two-factor",
  getNotificationSettings: "/api/v1/user/notification-settings",
  updateNotificationSettings: "/api/v1/user/notification-settings",
  getUserClassSummary: userId => `/api/v1/user/${userId}/class-summary`,
  getUserSpellbookSummary: userId => `/api/v1/user/${userId}/spellbook-summary`,
  getUserProjects: userId => `/api/v1/user/${userId}/projects`,
  getXpActivity: "/api/v1/user/me/xp-activity",
  searchUsers: (cityId, query = "") =>
    `/api/v1/users/${cityId}?search=${encodeURIComponent(query)}`,
  getUsersByCity: cityId => `/api/v1/users/${cityId}`,
  getCityMembers: cityId => `/api/v1/members/${cityId}`,
  getCitySpellbookSummary: cityId => `/api/v1/city/${cityId}/spellbook-summary`,
  inviteProjectMembers: projectId =>
    `/api/v1/projects/${projectId}/invitations/members`,
  requestProjectMemberLimit: projectId =>
    `/api/v1/projects/${projectId}/member-limit-requests`,

  //projects
  getProjects: "/api/v1/projects",
  getInvitedProject: "/api/v1/projects/invited",
  getProjectById: id => `/api/v1/projects/${id}`,
  getProjectStats: id => `/api/v1/projects/${id}/project-stats`,
  getProjectCollaboratorStats: projectId =>
    `/api/v1/projects/${projectId}/project-collaborator-stats`,
  createProject: "/api/v1/projects",
  createTask: id => `/api/v1/projects/${id}/tasks`,
  updateTask: (projectId, taskId) =>
    `/api/v1/projects/${projectId}/tasks/${taskId}`,
  deleteTask: (projectId, taskId) =>
    `/api/v1/projects/${projectId}/tasks/${taskId}`,
  updateTaskCollaborators: (projectId, taskId) =>
    `/api/v1/projects/${projectId}/tasks/${taskId}/collaborators`,
  updateTaskStatus: (projectId, taskId) =>
    `/api/v1/projects/${projectId}/tasks/${taskId}/status`,
  getMemberTaskSummary: "/api/v1/projects/tasks/member-summary",
  getProjectTasksDashboard: projectId =>
    `/api/v1/projects/${projectId}/tasks/dashboard`,
  updateProject: id => `/api/v1/projects/${id}`,
  acceptProjectMember: (projectId, memberId) =>
    `/api/v1/projects/${projectId}/members/${memberId}`,
  updateProjectMember: (projectId, memberId) =>
    `/api/v1/projects/${projectId}/members/${memberId}`,
  getSessions: "/api/v1/sessions",
  getActiveSession: "/api/v1/sessions/active",
  createSession: "/api/v1/sessions",
  getSessionById: id => `/api/v1/sessions/${id}`,
  getSessionCollaborators: id => `/api/v1/sessions/${id}/collaborators`,
  /** Same path as getSessionCollaborators — POST add / DELETE remove. */
  sessionCollaborators: id => `/api/v1/sessions/${id}/collaborators`,
  getSessionsCollaborators: "/api/v1/sessions/collaborators",
  deleteSession: id => `/api/v1/sessions/${id}`,
  joinSession: id => `/api/v1/sessions/${id}/join`,
  leaveSession: id => `/api/v1/sessions/${id}/leave`,
  sessionTimelog: id => `/api/v1/sessions/${id}/timelog`,
  sessionCollaboratorReactions: (sessionId, collaboratorId) =>
    `/api/v1/sessions/${sessionId}/collaborators/${collaboratorId}/reactions`,
  getAdminSessions: "/api/v1/admin/sessions",
  getAdminSessionById: id => `/api/v1/sessions/${id}`,
  getAdminSessionCollaborators: id => `/api/v1/sessions/${id}/collaborators`,
  getAdminSessionsSummary: "/api/v1/admin/sessions/summary",
  exportAdminSessions: "/api/v1/admin/sessions/export",
  getCategories: "/api/v1/public/categories",
  getTags: "/api/v1/public/tags?search",
  getProjectInvitations: "/api/v1/project-invitations",
  getProjectMemberById: memberId => `/api/v1/project-invitations/${memberId}`,
  deleteProjectInvitation: inviteId =>
    `/api/v1/project-invitations/${inviteId}`,
  respondProjectInvitation: inviteId =>
    `/api/v1/project-invitations/${inviteId}/respond`,
  getProjectMedia: "/api/v1/project-media",
  createProjectMedia: "/api/v1/project-media",
  deleteProjectMedia: id => `/api/v1/project-media/${id}`,
  uploadMessageMedias: "/api/v1/message/medias/upload",
  sendMessage: "/api/v1/messages/send",
  getMessageContexts: "/api/v1/messages/contexts",
  getDirectContacts: "/api/v1/messages/direct/contacts",
  getOrCreateDirectChat: userId =>
    `/api/v1/messages/direct/${encodeURIComponent(userId)}`,
  getMyProjectMembers: "/api/v1/project-members/my-members",
  getContextMessages: contextId =>
    `/api/v1/messages/contexts/${contextId}/messages`,
  postContextMessage: contextId =>
    `/api/v1/messages/contexts/${contextId}/messages`,
  postMessageReaction: messageId => `/api/v1/messages/${messageId}/reactions`,
  deleteMessageReaction: messageId => `/api/v1/messages/${messageId}/reactions`,
  updateMessage: messageId => `/api/v1/messages/${messageId}`,
  deleteMessage: messageId => `/api/v1/messages/${messageId}`,
  deleteMessageContext: contextId => `/api/v1/messages/contexts/${contextId}`,
  getInvitesSummary: "/api/v1/invites/summary",
  getInvites: "/api/v1/invites",
  getInviteBalanceHistory: "/api/v1/invites/balance-history",
  deleteInvite: inviteId => `/api/v1/invites/${inviteId}`,

  // calls for artist
  getCalls: "/api/v1/calls",
  getCallById: id => `/api/v1/calls/${id}`,
  createCall: "/api/v1/calls",
  updateCall: id => `/api/v1/calls/${id}/update`,
  deleteCall: id => `/api/v1/calls/${id}/delete`,
  getCallResponses: id => `/api/v1/calls/${id}/response`,
  createCallResponse: id => `/api/v1/calls/${id}/response`,
  getCallLikes: id => `/api/v1/calls/${id}/likes`,
  toggleCallResponseLike: (callId, responseId) =>
    `/api/v1/calls/${callId}/response/${responseId}/like`,
  getCityCalls: cityId => `/api/v1/city/${cityId}/calls`,
  getCityCallById: (cityId, callId) => `/api/v1/city/${cityId}/calls/${callId}`,
  getCityCallResponses: (cityId, callId) =>
    `/api/v1/city/${cityId}/calls/${callId}/response`,
  createCityCallResponse: (cityId, callId) =>
    `/api/v1/city/${cityId}/calls/${callId}/response`,
  deleteCityCallResponse: (cityId, callId, responseId) =>
    `/api/v1/city/${cityId}/calls/${callId}/response/${responseId}`,
  toggleCityCallResponseLike: (cityId, callId, responseId) =>
    `/api/v1/city/${cityId}/calls/${callId}/response/${responseId}/like`,
  getPhotography: "/api/v1/photography",
  createPhotography: "/api/v1/photography",
  getPhotographyById: id => `/api/v1/photography/${id}`,
  updatePhotography: id => `/api/v1/photography/${id}`,
  deletePhotography: id => `/api/v1/photography/${id}`,
  togglePhotographyReaction: id => `/api/v1/photography/${id}/react`,
  getPhotographyReactions: "/api/v1/photography/reactions/all",
  getCityPhotographyRequests: "/api/v1/city-photography-request",
  createCityPhotographyRequest: "/api/v1/city-photography-request",
  updateCityPhotographyRequest: id => `/api/v1/city-photography-request/${id}`,

  // city hub — local reviews (member)
  getReviewWriterRequests: "/api/v1/review-writer-request",
  getReviewWriterRequestById: id => `/api/v1/review-writer-request/${id}`,
  createReviewWriterRequest: "/api/v1/review-writer-request",
  updateReviewWriterRequest: id => `/api/v1/review-writer-request/${id}`,
  getCityReviews: cityId => `/api/v1/city/${cityId}/reviews`,
  getCityReviewById: (cityId, reviewId) =>
    `/api/v1/city/${cityId}/reviews/${reviewId}`,
  createReview: "/api/v1/reviews",
  getReviewById: id => `/api/v1/reviews/${id}`,
  updateReview: id => `/api/v1/reviews/${id}`,
  deleteReview: id => `/api/v1/reviews/${id}`,

  getDashboardStats: "/api/v1/dashboard-stats",
  getTasks: "/api/v1/tasks",
  getTaskById: id => `/api/v1/tasks/${id}`,
  getProjectsSummary: "/api/v1/projects/summary",
  getCalendarTasks: "/api/v1/tasks/calendar",
  getMyActivityLogs: "/api/v1/activity-logs/my",

  // flags
  getFlags: "/api/v1/flags",
  getMyFlags: "/api/v1/flags/my",
  getFlagById: id => `/api/v1/flags/${id}`,
  withdrawFlag: id => `/api/v1/flags/${id}/withdraw`,
  flagConversations: id => `/api/v1/flags/${id}/conversations`,
  createFlag: "/api/v1/flags",
  updateFlag: id => `/api/v1/flags/${id}`,
  getAdminFlags: "/api/v1/admin/flags",
  getAdminFlagById: id => `/api/v1/admin/flags/${id}`,
  updateAdminFlag: id => `/api/v1/admin/flags/${id}`,
  deleteAdminFlag: id => `/api/v1/admin/flags/${id}`,
  exportAdminFlags: "/api/v1/admin/flags/export",

  // notifications
  getNotifications: "/api/v1/notifications",
  markNotificationsRead: "/api/v1/notifications/read",
  getNotificationCount: "/api/v1/notifications/count",

  // rewards
  getAvailableRewards: "/api/v1/rewards/available",
  claimReward: id => `/api/v1/rewards/${id}/claim`,

  // admin
  getAdminInviteRequests: "/api/v1/admin/invites/requests",
  decideAdminInviteRequest: id => `/api/v1/admin/invites/requests/${id}`,
  exportAdminInviteRequests: "/api/v1/admin/invites/requests/export",
  getAdminCollaboratorLimits: "/api/v1/admin/collaborator-limits",
  updateAdminCollaboratorLimit: id =>
    `/api/v1/admin/collaborator-limits/update/${id}`,
  exportAdminCollaboratorLimits: "/api/v1/admin/collaborator-limits/export",
  getAdminCityUpdateRequests: "/api/v1/admin/city-update-requests",
  updateAdminCityUpdateRequest: id =>
    `/api/v1/admin/city-update-requests/update/${id}`,
  exportAdminCityUpdateRequests: "/api/v1/admin/city-update-requests/export",
  getAdminPhotographyCollaborators: "/api/v1/admin/photography-collaborator",
  getAdminPhotographyCollaboratorById: id =>
    `/api/v1/admin/photography-collaborator/${id}`,
  createAdminPhotographyCollaborator: "/api/v1/admin/photography-collaborator",
  updateAdminPhotographyCollaboratorStatus: id =>
    `/api/v1/admin/photography-collaborator/update_status/${id}`,
  deleteAdminPhotographyCollaborator: id =>
    `/api/v1/admin/photography-collaborator/${id}`,
  exportAdminPhotographyCollaborators:
    "/api/v1/admin/photography-collaborator/export",
  getAdminPhotography: "/api/v1/admin/photography",
  getAdminPhotographyById: id => `/api/v1/admin/photography/${id}`,
  exportAdminPhotography: "/api/v1/admin/photography/export",
  getAdminReviewWriterRequests: "/api/v1/admin/review-writer-request",
  getAdminReviewWriterRequestById: id =>
    `/api/v1/admin/review-writer-request/${id}`,
  createAdminReviewWriterRequest: "/api/v1/admin/review-writer-request",
  updateAdminReviewWriterRequestStatus: id =>
    `/api/v1/admin/review-writer-request/update_status/${id}`,
  deleteAdminReviewWriterRequest: id =>
    `/api/v1/admin/review-writer-request/${id}`,
  exportAdminReviewWriterRequests:
    "/api/v1/admin/reviews-update-request/export",
  getAdminRequestsCounts: "/api/v1/admin/requests/counts",
  getAdminReviews: "/api/v1/admin/reviews",
  getAdminReviewById: id => `/api/v1/admin/reviews/${id}`,
  createAdminReview: "/api/v1/admin/reviews",
  updateAdminReview: id => `/api/v1/admin/reviews/${id}`,
  deleteAdminReview: id => `/api/v1/admin/reviews/${id}`,
  exportAdminReviews: "/api/v1/admin/reviews/export",
  getAdminDashboardStats: "/api/v1/admin/dashboard/stats",
  getAdminPlatformOverview: "/api/v1/admin/dashboard/platform-overview",
  getAdminModuleUsage: "/api/v1/admin/dashboard/module-usage",
  getAdminMembersByCity: "/api/v1/admin/dashboard/members-by-city",
  getAdminActivityLogs: "/api/v1/admin/activity-logs",
  exportAdminActivityLogs: "/api/v1/admin/activity-logs/export",
  getAdminCities: "/api/v1/admin/cities",
  getAdminCitiesSummary: "/api/v1/admin/cities/summary",
  exportAdminCities: "/api/v1/admin/cities/export",
  createAdminCity: "/api/v1/admin/cities",
  updateAdminCity: id => `/api/v1/admin/cities/${id}`,
  deleteAdminCity: id => `/api/v1/admin/cities/${id}`,
  getAdminProjects: "/api/v1/admin/projects",
  exportAdminProjects: "/api/v1/admin/projects/export",
  getAdminRoles: "/api/v1/admin/roles/get-all",
  getAdminRolesSummary: "/api/v1/admin/roles/summary",
  getAdminRoleById: id => `/api/v1/admin/roles/get-single/${id}`,
  createAdminRole: "/api/v1/admin/roles/create",
  updateAdminRole: id => `/api/v1/admin/roles/update/${id}`,
  deleteAdminRole: id => `/api/v1/admin/roles/delete/${id}`,
  getAdminPermissions: "/api/v1/admin/permissions/get-all",
  getAdminRoleTypes: "/api/v1/admin/role-types",
  getAdminRoleTypesSummary: "/api/v1/admin/role-types/summary",
  exportAdminRoleTypes: "/api/v1/admin/role-types/export",
  getAdminRoleTypeById: id => `/api/v1/admin/role-types/${id}`,
  createAdminRoleType: "/api/v1/admin/role-types",
  updateAdminRoleType: id => `/api/v1/admin/role-types/${id}`,
  deleteAdminRoleType: id => `/api/v1/admin/role-types/${id}`,
  getAdminSpellbooks: "/api/v1/admin/spellbooks",
  exportAdminSpellbooks: "/api/v1/admin/spellbooks/export",
  createAdminSpellbooks: "/api/v1/admin/spellbooks",
  updateAdminSpellbook: id => `/api/v1/admin/spellbooks/${id}`,
  deleteAdminSpellbook: id => `/api/v1/admin/spellbooks/${id}`,
  getAdminRoleClasses: "/api/v1/admin/role-classes",
  exportAdminRoleClasses: "/api/v1/admin/role-classes/export",
  createAdminRoleClasses: "/api/v1/admin/role-classes",
  updateAdminRoleClass: id => `/api/v1/admin/role-classes/${id}`,
  deleteAdminRoleClass: id => `/api/v1/admin/role-classes/${id}`,
  getAdminStaff: "/api/v1/admin/staff/list",
  getAdminStaffSummary: "/api/v1/admin/staff/summary",
  exportAdminStaff: "/api/v1/admin/staff/export",
  getAdminStaffById: id => `/api/v1/admin/staff/get-single/${id}`,
  createAdminStaff: "/api/v1/admin/staff/create",
  updateAdminStaff: id => `/api/v1/admin/staff/update/${id}`,
  deleteAdminStaff: id => `/api/v1/admin/staff/delete/${id}`,
  updateAdminStaffStatus: id => `/api/v1/admin/staff/${id}/status`,
  getAdminMembers: "/api/v1/admin/members",
  getAdminMembersSummary: "/api/v1/admin/members/users-summary",
  exportAdminMembers: "/api/v1/admin/members/export",
  getAdminMember: memberId =>
    `/api/v1/admin/members/${encodeURIComponent(memberId)}`,
  getAdminMemberByEmail: email =>
    `/api/v1/admin/members/${encodeURIComponent(email)}`,
  createAdminMemberInvite: "/api/v1/admin/invites",
  updateAdminMemberPassword: id => `/api/v1/admin/members/${id}/password`,
  getAdminRewards: "/api/v1/admin/rewards",
  getAdminRewardById: id => `/api/v1/admin/rewards/${id}`,
  getAdminRewardsStats: "/api/v1/admin/rewards/stats",
  createAdminReward: "/api/v1/admin/rewards",
  updateAdminReward: id => `/api/v1/admin/rewards/${id}`,
  deleteAdminReward: id => `/api/v1/admin/rewards/${id}`,
  exportAdminRewards: "/api/v1/admin/rewards/export",
  getAdminRewardTypes: "/api/v1/admin/reward-types/dropdown",
  getAdminRewardClaims: "/api/v1/admin/reward-claims",
  deleteAdminRewardClaim: id => `/api/v1/admin/reward-claims/${id}`,
  getAdminCalls: "/api/v1/admin/calls",
  getAdminCallById: id => `/api/v1/admin/calls/${id}`,
  updateAdminCall: id => `/api/v1/admin/calls/update/${id}`,
  getAdminCallsSummary: "/api/v1/admin/calls/summary",
  exportAdminCalls: "/api/v1/admin/calls/export",

  // realtime / presence (backend auth for private & presence channels)
  pusherAuth: "/api/v1/socket/auth",
}

export default endpoints
